module.exports = __webpack_public_path__ + "img/運勢書banner文字_mobile.9714e57c.png";